import React from 'react';
import {Card} from '../../../../_metronic/_partials/controls';
import {UsersClientActionsFilter} from './UsersClientActionsFilter.js';
import {UsersClientActionsTable} from './UsersClientActionsTable';
import {UsersClientActionsFooter} from './UsersClientActionsFooter';
import FooterBar from '../../_common/components/FooterBar';

export function UsersClientActionsCard() {

  return (
    <Card className={'flex-fill bg-transparent shadow-none'} id={'users-actions-list-card'}>
      <UsersClientActionsFilter/>
      <UsersClientActionsTable/>
      <FooterBar>
        <UsersClientActionsFooter/>
      </FooterBar>
    </Card>
  );
}
